import { useContext } from 'react';
import { GlobalContext } from '../context/GlobalState';
import { updateDeliveryIsSelected, validateCheckout } from '../functions';

const Post = props => {
	const [ dispatch, notify ] = useContext( GlobalContext );

	return (
		<div className="digital-code-post">
			<h1>Skicka registreringskoder som post</h1>
			<p>Registreringskoderna skickas i en folder till leveransadressen som anges på ordern.</p>

			<nav className="group-right">
				<a className="button btn-fifthary" onClick={ () => { // eslint-disable-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
					notify( null );

					dispatch( {
						type: 'SET_STEP',
						payload: 'select',
					} );
				} }>Tillbaka</a>

				<a className="button btn-secondary" onClick={ () => { // eslint-disable-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
					dispatch( {
						type: 'SET_IS_LOADING',
						payload: true,
					} );
					// eslint-disable-next-line no-undef
					fetch( sisuReact.admin_ajax, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded',
							'Access-Control-Allow-Origin': '*',
						},
						credentials: 'same-origin',
						body: new URLSearchParams( {
							action: 'digital_code_save_line_meta',
							// eslint-disable-next-line no-undef
							nonce: sisuReact.nonce,
							cartItemKey: props.cartItemKey,
							distributionMethod: 'FOLDER',
						} ),
					} ).then( function( response ) {
						return response.json();
					} ).then( function( data ) {
						dispatch( {
							type: 'SET_IS_LOADING',
							payload: false,
						} );
						if ( 'false' === data ) {
							notify( 'Något gick fel. Försök igen.' );
						} else {
							notify( 'Ändring sparad.', 'success' );
							updateDeliveryIsSelected( props.cartItemKey, 'true' );
							validateCheckout();
							dispatch( {
								type: 'SET_IS_SAVED',
								payload: true,
							} );
							setTimeout( () => {
								dispatch( {
									type: 'SET_OVERLAY_VISIBILITY',
									payload: false,
								} );
							}, 1000 );
						}
					} );
				} }>Spara</a>
			</nav>
		</div>
	);
};

export default Post;
